<rask-button
  aid="buttonHamtaHistorik"
  color="primary"
  (click)="hamtaHistorik()"
  [disabled]="canGetHistorik()">
  Hämta Händelser
</rask-button>
<rask-toggle-panel label="Förstaledskontrakt" [defaultExpanded]="false">
  <ng-container>
    @if (eventsVievModel?.originalContractEvents) {
      <rask-list [data]="eventsVievModel.originalContractEvents">
        <rask-list-column header="Händelse" field="event" width="900px"></rask-list-column>
        <rask-list-column header="Tidpunkt" field="datum"></rask-list-column>
        <rask-list-column header="Användare" field="anvandare"></rask-list-column>
      </rask-list>
    }
  </ng-container>
</rask-toggle-panel>
<rask-toggle-panel label="Avtalsobjekt" [defaultExpanded]="false">
  <ng-container>
    @if (eventsVievModel?.deliverysourceEvents) {
      <rask-list [data]="eventsVievModel.deliverysourceEvents">
        <rask-list-column header="Händelse" field="event" width="900px"></rask-list-column>
        <rask-list-column header="Tidpunkt" field="datum"></rask-list-column>
        <rask-list-column header="Användare" field="anvandare"></rask-list-column>
      </rask-list>
    }
  </ng-container>
</rask-toggle-panel>
<rask-toggle-panel label="Produktionsunderlag" [defaultExpanded]="false">
  <ng-container>
    @if (eventsVievModel?.forestloggingEvents) {
      <rask-list [data]="eventsVievModel.forestloggingEvents">
        <rask-list-column header="Händelse" field="event" width="900px"></rask-list-column>
        <rask-list-column header="Tidpunkt" field="datum"></rask-list-column>
        <rask-list-column header="Användare" field="anvandare"></rask-list-column>
      </rask-list>
    }
  </ng-container>
</rask-toggle-panel>
<rask-toggle-panel label="Destinering" [defaultExpanded]="false">
  <ng-container>
    @if (eventsVievModel?.orderConfirmationEvents) {
      <rask-list [data]="eventsVievModel.orderConfirmationEvents">
        <rask-list-column header="Händelse" field="event" width="900px"></rask-list-column>
        <rask-list-column header="Tidpunkt" field="datum"></rask-list-column>
        <rask-list-column header="Användare" field="anvandare"></rask-list-column>
      </rask-list>
    }
  </ng-container>
</rask-toggle-panel>
<rask-toggle-panel label="Transportunderlag" [defaultExpanded]="false">
  <ng-container>
    @if (eventsVievModel?.loadTenderLogEvents) {
      <rask-list [data]="eventsVievModel.loadTenderLogEvents">
        <rask-list-column header="Händelse" field="event" width="900px"></rask-list-column>
        <rask-list-column header="Tidpunkt" field="datum"></rask-list-column>
        <rask-list-column header="Användare" field="anvandare"></rask-list-column>
      </rask-list>
    }
  </ng-container>
</rask-toggle-panel>

